export const getSearchOffersTitle = (title: string, isActive: boolean): string => {
  const translatedTitle = title;

  if (isActive) {
    return `${translatedTitle} (*)`;
  } else {
    return translatedTitle;
  }
};
